/* tslint:disable */
import {
  DonationCategory
} from '../index';

declare var Object: any;
export interface OrganizationInterface {
  "name": string;
  "logo": string;
  "info"?: string;
  "thankYouImg"?: string;
  "id"?: any;
  "donationCategoryId"?: any;
  donationCategory?: DonationCategory;
}

export class Organization implements OrganizationInterface {
  "name": string;
  "logo": string;
  "info": string;
  "thankYouImg": string;
  "id": any;
  "donationCategoryId": any;
  donationCategory: DonationCategory;
  constructor(data?: OrganizationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Organization`.
   */
  public static getModelName() {
    return "Organization";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Organization for dynamic purposes.
  **/
  public static factory(data: OrganizationInterface): Organization{
    return new Organization(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Organization',
      plural: 'organizations',
      path: 'organizations',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "logo": {
          name: 'logo',
          type: 'string'
        },
        "info": {
          name: 'info',
          type: 'string'
        },
        "thankYouImg": {
          name: 'thankYouImg',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "donationCategoryId": {
          name: 'donationCategoryId',
          type: 'any'
        },
      },
      relations: {
        donationCategory: {
          name: 'donationCategory',
          type: 'DonationCategory',
          model: 'DonationCategory',
          relationType: 'belongsTo',
                  keyFrom: 'donationCategoryId',
          keyTo: 'id'
        },
      }
    }
  }
}
